import { createContext, useContext } from "react"
import type { NoteProps } from "./index"
import type { FocusTarget } from "./note-focus"

export type NoteVariant = NonNullable<NoteProps["variant"]>

export type NoteContextValue = {
  variant: NoteVariant
  headingId: string
  registerHeading: () => () => void
  dismiss: (focusTarget?: FocusTarget) => void
}

export const NoteContext = createContext<NoteContextValue | null>(null)

export function useNoteContext(): NoteContextValue {
  const context = useContext(NoteContext)

  if (!context) throw new Error("useNoteContext must be used within a Note")

  return context
}
